<template>
  <div :id="'dropdown-'+rowData.id"
       class="dropdown keep-inside-clicks-open dropdown-note-editor d-inline-block">
    <button v-if="rowData.subscription" type="button"
            class="btn p-0 primary-text-color"
            data-toggle="dropdown">
      <app-icon name="file-text" :class="iconClass"/>
    </button>
    <div v-if="rowData.subscription" class="dropdown-menu p-primary mt-1">
      <div>
        <p class="text-secondary">
          {{ resourcesTitle }}
        </p>
        <div class="note note-info custom-scrollbar p-4 mb-5">
          <p class="text-muted text-nowrap" v-for="(singleResource, index) in rowData.subscription.resources">
            {{ $t(index) }} : {{ singleResource ?? 'false' }}
          </p>
        </div>
        <p class="text-secondary">
          {{ resourcesUsedTitle }}
        </p>
        <div class="note note-warning custom-scrollbar p-4 mb-5">
          <p class="text-muted text-nowrap" v-for="(singleResource, index) in rowData.subscription.resources_used">
            {{ $t(index) }} : {{ singleResource ?? 'false' }}
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import LeaveLogNote from "./LeaveLogNote";
// import LeaveLogContent from "./LeaveLogContent";

export default {
  name: "TenantResourceModal",
  // components: {LeaveLogContent,LeaveLogNote},
  // mixins: [ModalMixin, FormHelperMixins],
  props: {
    rowData: {},
    iconClass: {
      default: 'size-18'
    },
  },
  mounted() {
  },
  computed: {
    resourcesTitle() {
      return this.$t('resources');
    },
    resourcesUsedTitle() {
      return this.$t('resources_used');
    }
  },
  methods: {},
}
</script>